import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Alert, Form } from "react-bootstrap";
import RevShareModal from "../../common/overrides/RevShareModal";
import { addFaq, editFaq } from "../../../redux/actions/FaQActions";
import { SAVE_NEW_FAQ_SUCCESS, UPDATE_FAQ_SUCCESS } from "../../../redux/actions/ActionTypes";
import QandA from "./QandA";

class FAQEditorModal extends Component {
  render() {
    return (
      <RevShareModal
        api={this.props.question ? UPDATE_FAQ_SUCCESS : SAVE_NEW_FAQ_SUCCESS}
        buttonText={this.props.question ? "Edit" : "Add"}
        buttonVariant="secondary"
        title={this.props.question ? "Edit FAQ" : "Add FAQ"}
        yesButtonOnClick={this.submit}
      >
        <Alert dismissible onClose={this.toggleShowErrors} show={this.state.showErrors} variant="danger">
          <Alert.Heading>There are issues with your submission:</Alert.Heading>
          <ul>
            {this.state.errors.map((error) => (
              <li>{error}</li>
            ))}
          </ul>
        </Alert>
        <Form>
          <Form.Group>
            <Form.Label>Question</Form.Label>
            <Form.Control
              as="textarea"
              onChange={this.onChange}
              ref={(element) => (this.questionEntry = element)}
              rows="3"
              value={this.state.question.question}
            >
              {this.state.question.question}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Answer (Supports Markdown)</Form.Label>
            <Form.Control
              as="textarea"
              onChange={this.onChange}
              ref={(element) => (this.answerEntry = element)}
              rows="5"
              value={this.state.question.answer}
            ></Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>More Details (Supports Markdown)</Form.Label>
            <Form.Control
              as="textarea"
              onChange={this.onChange}
              ref={(element) => (this.detailsEntry = element)}
              rows="10"
              value={this.state.question.details}
            ></Form.Control>
          </Form.Group>
        </Form>
        <h3>Preview</h3>
        <QandA
          isAdmin={false}
          onVoteClick={() => {
            return;
          }}
          question={this.state.question}
        />
      </RevShareModal>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      question: {
        question: props.question ? props.question.question : "",
        answer: props.question ? props.question.answer : "",
        details: props.question && props.question.details ? props.question.details : "",
      },
      maxLengths: {
        question: 200,
        answer: 500,
        details: 2500,
      },
      errors: [],
      showErrors: false,
    };

    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
    this.validateEntryLengths = this.validateEntryLengths.bind(this);
    this.toggleShowErrors = this.toggleShowErrors.bind(this);
  }

  onChange() {
    const question = {
      question: this.questionEntry.value,
      answer: this.answerEntry.value,
      details: this.detailsEntry.value,
    };
    this.setState({ question: question });
  }

  submit(event) {
    this.setState({ errors: [] });
    if (this.validateEntryLengths()) {
      const question = {
        question: this.questionEntry.value.trim(),
        answer: this.answerEntry.value.trim(),
        details: this.detailsEntry.value.trim(),
      };
      this.setState({ question: question, saving: true });
      if (this.props.question) {
        return this.props.editFaq(this.props.question.questionId, this.state.question);
      } else {
        return this.props.addFaq(this.state.question);
      }
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  validateEntryLengths() {
    let errors = [];
    if (this.questionEntry.value.trim().length > 200) {
      errors.push(`Question cannot exceed 200 characters. (currently ${this.questionEntry.value.length})`);
    }
    if (this.answerEntry.value.trim().length > 500) {
      errors.push(`Answer cannot exceed 500 characters. (currently ${this.questionEntry.value.length})`);
    }
    if (this.detailsEntry.value.trim().length > 2500) {
      errors.push(`Details cannot exceed 2500 characters. (currently ${this.questionEntry.value.length})`);
    }

    if (errors.length > 0) {
      this.setState({ errors, showErrors: true });
      return false;
    } else {
      return true;
    }
  }

  toggleShowErrors() {
    this.setState({ showErrors: !this.state.showErrors });
  }
}

FAQEditorModal.propTypes = {
  question: PropTypes.object,
};

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = {
  addFaq,
  editFaq,
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQEditorModal);
